<span *ngIf="value > 0" [title]="value" [ngClass]="{ badge: !small, 'badge-small': small }" class="badge-pill badge-primary">{{ value > 9 ? '9+' : (value | number) }}</span>
